export default class ReduxUtils {
    /**
     * Create a function that takes extracts given argument names from its own argument names and puts it
     * into an 'action' object that is then return.
     *
     * @param type string  True of action
     * @param argNames array Array of argument names to extract
     *
     * @returns {function(...[*]): {type: *}} Function that creates an action
     */
    static createAction(type, ...argNames) {
        return (...args) => {
            const action = { type };
            argNames.forEach((arg, index) => {
                action[argNames[index]] = args[index];
            });
            return action;
        };
    }
    /**
     * Create a reducer
     *
     * @param initialState Initial state of the app
     * @param handlers A map of action type string to a function that should be invoked when an action of given
     *                  type is dispatched. The function accepts 'state' and 'action'.
     *
     * @returns {Function} Redux reducer
     */
    static createReducer(initialState, handlers) {
        return (state, action) => {
            if (typeof state === 'undefined') {
                return initialState;
            }
            if (typeof handlers[action.type] === 'function') {
                return handlers[action.type](state, action);
            }
            return state;
        };
    }
}
//# sourceMappingURL=ReduxUtils.js.map